import { useMemo, useEffect } from 'react';

/**
 * Creates an object URL from a Blob and automatically cleans it up
 * when the blob changes or the component unmounts.
 *
 * @param blob - The Blob to create a URL for, or null
 * @returns A blob URL string, or empty string if blob is null
 */
export function useBlobUrl(blob: Blob | null): string {
  const url = useMemo(() => (blob ? URL.createObjectURL(blob) : ''), [blob]);

  useEffect(() => {
    return () => {
      if (url) {
        URL.revokeObjectURL(url);
      }
    };
  }, [url]);

  return url;
}
